var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-footer',[_vm._v("Footer")])
}
var staticRenderFns = []

export { render, staticRenderFns }